import { messageQueueTypes } from '@/components/MQ/mq.types';
import * as navTabs from '@/utils/templates/mqTemplate/mq.constants';
import i18n from '@/plugins/i18n';

export const getMQNavTabs = () => [
  {
    activeTab: messageQueueTypes.amq,
    tabs: [
      {
        key: navTabs.NAVTAB_AMQ_KEY.OVERVIEW,
        label: i18n.global.t('mq.overview'),
      },
      {
        key: navTabs.NAVTAB_AMQ_KEY.QUEUES,
        label: i18n.global.t('mq.queues'),
      },
      {
        key: navTabs.NAVTAB_AMQ_KEY.TOPICS,
        label: i18n.global.t('mq.topics'),
      },
    ],
  },
  {
    activeTab: messageQueueTypes.kafka,
    tabs: [
      {
        key: navTabs.NAVTAB_KAFKA_KEY.OVERVIEW,
        label: i18n.global.t('mq.overview'),
      },
      {
        key: navTabs.NAVTAB_KAFKA_KEY.BROKER,
        label: i18n.global.t('mq.broker'),
      },
      {
        key: navTabs.NAVTAB_KAFKA_KEY.ZOOKEEPER,
        label: i18n.global.t('mq.zooKeeper'),
      },
      {
        key: navTabs.NAVTAB_KAFKA_KEY.PRODUCER,
        label: i18n.global.t('mq.producer'),
      },
      {
        key: navTabs.NAVTAB_KAFKA_KEY.CONSUMER,
        label: i18n.global.t('mq.consumer'),
      },
    ],
  },
];

const mq = {
  key: 'mq',
  name: i18n.global.t('mq.mqMonitoring'),
  icon: 'mq',
  navTabs: getMQNavTabs(),
};

export default mq;
